import React from 'react';
import { useNavigate } from 'react-router-dom';

function Error404() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background Image Layer */}
      <div className="absolute inset-0 cyber-auth-bg" />
      {/* Dynamic Overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-cyan-900/20 via-[#030305]/80 to-[#030305]/90" />
      
      <div className="relative z-10 w-full max-w-2xl text-center">
        <div className="cyber-card p-12 border-red-500 shadow-[0_0_30px_rgba(255,0,0,0.2)]">
          {/* Glitch 404 */}
          <div className="relative inline-block mb-8">
            <h1 className="text-[12rem] font-black leading-none tracking-tighter select-none text-red-500 drop-shadow-[0_0_15px_rgba(255,0,0,0.8)]"
              style={{
                clipPath: 'polygon(0 0, 100% 0, 100% 45%, 0 45%, 0 55%, 100% 55%, 100% 100%, 0 100%)'
              }}>
              404
            </h1>
            <div className="absolute inset-0 text-[12rem] font-black leading-none tracking-tighter select-none text-cyan-400 opacity-50"
              style={{
                transform: 'translate(-5px, 2px)',
                clipPath: 'polygon(0 45%, 100% 45%, 100% 55%, 0 55%)'
              }}>
              404
            </div>
            <div className="absolute inset-0 text-[12rem] font-black leading-none tracking-tighter select-none text-fuchsia-500 opacity-50"
              style={{
                transform: 'translate(5px, -2px)',
                clipPath: 'polygon(0 0, 100% 0, 100% 15%, 0 15%, 0 85%, 100% 85%, 100% 100%, 0 100%)'
              }}>
              404
            </div>
          </div>

          <div className="inline-flex items-center gap-2 px-4 py-2 border border-red-500/50 bg-red-900/20 text-red-500 text-xs font-bold uppercase tracking-widest mb-6" style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%)' }}>
            <span className="w-2 h-2 bg-red-500 animate-pulse" />
            NODE_NOT_FOUND
          </div>

          <h2 className="text-3xl font-black text-white tracking-widest uppercase drop-shadow-[0_0_8px_rgba(255,255,255,0.3)] mb-4">
            FATAL_ERROR: DEAD LINK
          </h2>
          <p className="mb-10 max-w-md mx-auto cyber-label text-[10px] leading-relaxed">
            THE REQUESTED DATA NODE DOES NOT EXIST IN THE MAINFRAME DIRECTORY. IT MAY HAVE BEEN PURGED OR THE IDENTIFIER IS INCORRECT.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={() => navigate('/')}
              className="cyber-btn py-4 px-8 text-sm">
              RETURN_TO_BASE
            </button>
            <button onClick={() => navigate(-1)}
              className="cyber-btn border-fuchsia-800 text-fuchsia-500 hover:border-fuchsia-400 hover:text-fuchsia-400 py-4 px-8 text-sm">
              TRACE_BACK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error404;
